import { IDomain, IStat } from "../../types";
import { DomainActionsTypes } from "../actions/domainActions";

export const IS_DOMAINS_LOADING_IN_PROGRESS =
  "domain/IS_DOMAINS_LOADING_IN_PROGRESS";
export const SET_DOMAINS = "domain/SET_DOMAINS";
export const IS_DOMAINS_CREATING_IN_PROGRESS =
  "domain/IS_DOMAINS_CREATING_IN_PROGRESS";
export const IS_DOMAINS_UPDATING_IN_PROGRESS =
  "domain/IS_DOMAINS_UPDATING_IN_PROGRESS";
export const SET_IS_LOAD_STATISTIC_IN_PROGRESS =
  "domain/SET_IS_LOAD_STATISTIC_IN_PROGRESS";
export const SET_STATISTICS = "domain/SET_STATISTICS";
export const SET_IS_LOAD_CLICKS_IN_PROGRESS =
  "domain/SET_IS_LOAD_CLICKS_IN_PROGRESS";
export const SET_CLICKS = "domain/SET_CLICKS";
export const SET_IS_LOAD_CLICKS_BY_DATE_IN_PROGRESS =
  "domain/SET_IS_LOAD_CLICKS_BY_DATE_IN_PROGRESS";
export const SET_CLICKS_BY_DATE = "domain/SET_CLICKS_BY_DATE";
export const SET_CLICKS_DATES = "domain/SET_CLICKS_DATES";
export const SET_IS_CREATING_SITES_FROM_CATEGORY_IN_PROGRESS =
  "domain/SET_IS_CREATING_SITES_FROM_CATEGORY_IN_PROGRESS";

const initialState = {
  domains: [] as IDomain[],
  isDomainsLoadingInProgress: false,
  isDomainsCreatingInProgress: false,
  isDomainsUpdatingInProgress: false,
  isLoadStatisticInProgress: false,
  isLoadClicksInProgress: false,
  isLoadClicksByDateInProgress: false,
  isCreatingSitesFromCategoryInProgress: false,
  statistics: "",
  clicks: 0,
  clicksByDate: [] as IStat[],
  clicksStartDate: null as null | string,
  clicksEndDate: null as null | string,
};

type InitialStateType = typeof initialState;

export const domainReducer = (
  state = initialState,
  action: DomainActionsTypes
): InitialStateType => {
  switch (action.type) {
    case SET_DOMAINS:
    case IS_DOMAINS_LOADING_IN_PROGRESS:
    case IS_DOMAINS_CREATING_IN_PROGRESS:
    case IS_DOMAINS_UPDATING_IN_PROGRESS:
    case SET_IS_LOAD_STATISTIC_IN_PROGRESS:
    case SET_STATISTICS:
    case SET_IS_LOAD_CLICKS_IN_PROGRESS:
    case SET_IS_LOAD_CLICKS_BY_DATE_IN_PROGRESS:
    case SET_CLICKS:
    case SET_CLICKS_BY_DATE:
    case SET_CLICKS_DATES:
    case SET_IS_CREATING_SITES_FROM_CATEGORY_IN_PROGRESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
